import { ConfigProvider } from 'antd';
import '../pages/teacher/TeacherDashboard.css';
import '../pages/teacher/TeacherInnerFresh.css';
import React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  HomeOutlined,
  HomeFilled,
  TeamOutlined,
  PlusOutlined,
  FormOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { accent, brass, neutral, gradient, shadow } from '../theme/tokens';
import { FEATURE_FLAGS } from '../featureFlags';

const tabs = [
  { key: '/teacher', icon: <HomeOutlined />, activeIcon: <HomeFilled />, label: '工作台' },
  { key: '/teacher/students', icon: <TeamOutlined />, activeIcon: <TeamOutlined />, label: '班级' },
  { key: '/teacher/record', icon: <PlusOutlined />, activeIcon: <PlusOutlined />, label: '记录', primary: true },
  // 测评入口受 FEATURE_FLAGS.ENABLE_ASSESSMENT 控制，关闭时整个 tab 不渲染
  ...(FEATURE_FLAGS.ENABLE_ASSESSMENT
    ? [{ key: '/teacher/assessments', icon: <FormOutlined />, activeIcon: <FormOutlined />, label: '测评' }]
    : []),
  { key: '/teacher/me', icon: <UserOutlined />, activeIcon: <UserOutlined />, label: '我的' },
];

const TeacherLayout: React.FC = () => {
 const navigate=useNavigate(); const {pathname}=useLocation();
 const activeKey=pathname.startsWith('/teacher/student')?'/teacher/students':tabs.find(t=>pathname===t.key)?.key||tabs.find(t=>t.key!=='/teacher'&&pathname.startsWith(t.key+'/'))?.key||'/teacher';
 return <div className="teacher-shell teacher-fresh-shell" style={{minHeight:'100vh',paddingBottom:92}}>
 <ConfigProvider theme={{token:{colorPrimary:'#527b2e',colorText:'#161a28',colorBorder:'#e5e7ee',borderRadius:14,controlHeight:42},components:{Button:{primaryShadow:'none'}}}}><Outlet/></ConfigProvider>
 <nav className="teacher-bottom-nav" aria-label="教师端导航">{tabs.map(tab=><button type="button" key={tab.key} onClick={()=>navigate(tab.key)} aria-current={activeKey===tab.key?'page':undefined} className={'teacher-nav-item'+(tab.primary?' is-primary':'')}><span className="teacher-nav-icon">{activeKey===tab.key?tab.activeIcon:tab.icon}</span><span>{tab.label}</span></button>)}</nav>
 </div>;
};
export default TeacherLayout;
